export const formatCurrency = (amount: number): string => {
  const formatter = new Intl.NumberFormat("en-NZ", {
    style: "currency",
    currency: "NZD",
    minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
    currencyDisplay: "narrowSymbol",
  });

  return formatter.format(amount);
};

export const formatDate = (date: string | Date | undefined): string => {
  if (!date) return "";

  const formatter = new Intl.DateTimeFormat("en-NZ", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  return formatter.format(new Date(date));
};
